import { createFileRoute, redirect } from "@tanstack/react-router";

import { IntegrationsPage } from "@/features/integrations/IntegrationsPanel";

export const Route = createFileRoute("/_app/integrations")({
  beforeLoad: ({ context }) => {
    // The laptop's integrations live on the admin page; this page is the cloud's, for platform admins.
    if (context.info.edition !== "cloud" || !context.me?.roles.some((r) => r.role === "platform_admin")) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: IntegrationsPage,
});
